export const toBase64 = (file: File) => new Promise<string>((resolve, reject) => {
    console.log(file.type)
    const reader = new FileReader();
    reader.onload = () => resolve((reader.result as string).split(',')[1]);
    reader.onerror = error => reject(error);
    reader.readAsDataURL(file);
});

export const fromBase64 = (fileData: string, name: string, type: string) => {
    return new File([fileData], name, {type: "application/pdf"})
}